<template>
  <app-shop></app-shop>
</template>

<script>
import AppShop from "@/components/shop/appShop";
export default {
  name: "design_auto_app",
  components: {AppShop}
}
</script>

<style scoped>

</style>